import React from 'react';
import { MapPin } from 'lucide-react';
import Modal from '../../../../shared/components/ui/Modal';
import { OUTCOME_LABELS, mapUrl } from './visitGroups';

const time = (v) =>
  v ? new Date(v).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' }) : '—';

const MapLink = ({ lat, lng, label }) => {
  const url = mapUrl(lat, lng);
  if (!url) return <span className="text-gray-400">{label}: no location</span>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1 text-[#2A565E] hover:underline">
      <MapPin size={12} /> {label}
    </a>
  );
};

/** One person's customer visits for one day, as recorded from the app. */
const VisitsModal = ({ open, title, subtitle, visits, onClose }) => {
  if (!open) return null;
  return (
    <Modal name={title} onClose={onClose} width="560px">
      <div className="space-y-3">
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
        {visits.map((v) => (
          <div key={v.id} className="border border-gray-200 rounded-lg p-3 space-y-1.5">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-medium text-gray-900">{v.customer_name}</div>
                <div className="text-xs text-gray-500">
                  {[v.customer_phone, v.purpose].filter(Boolean).join(' · ') || '—'}
                </div>
              </div>
              {v.outcome && (
                <span className="shrink-0 text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                  {OUTCOME_LABELS[v.outcome] ?? v.outcome}
                </span>
              )}
            </div>
            <div className="text-xs text-gray-600">
              {time(v.started_at)} – {v.ended_at ? time(v.ended_at) : 'still open'}
              {v.duration_minutes != null ? ` · ${v.duration_minutes} min` : ''}
            </div>
            {v.notes && (
              <p className="text-sm text-gray-800 whitespace-pre-line">
                <span className="text-gray-500">Notes: </span>
                {v.notes}
              </p>
            )}
            {v.customer_feedback && (
              <p className="text-sm text-gray-800 whitespace-pre-line">
                <span className="text-gray-500">Customer said: </span>
                {v.customer_feedback}
              </p>
            )}
            <div className="flex flex-wrap gap-4 text-xs pt-1">
              <MapLink lat={v.start_lat} lng={v.start_lng} label="Start" />
              <MapLink lat={v.end_lat} lng={v.end_lng} label="End" />
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default VisitsModal;
